export type LabType = "design" | "transfers";

export const LAB_TYPE = {
  DESIGN: "design",
  TRANSFERS: "transfers"
} as const;
